import { Component, computed, inject, output } from '@angular/core';
import { FlowpilotChatService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-chat.service';
import { FlowpilotChatItemComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chat-item.component';

@Component({
  selector: 'app-flowpilot-chats-lists',
  imports: [FlowpilotChatItemComponent],
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    @for (chatType of chatTypes; track chatType.name) {
      @if (chatType.data().length) {
        <div
          class="flex size-full max-h-min flex-col gap-y-0.5 overflow-hidden">
          <span class="text-dune-400 dark:text-dune-500 pl-[7px] text-xs">
            {{ chatType.name }}
          </span>

          <div
            class="flex size-full max-h-min flex-col gap-y-0.5 overflow-auto">
            @for (chat of chatType.data(); track chat.id) {
              <app-flowpilot-chat-item
                [chat]="chat"
                [selected]="selectedChat()?.id === chat.id"
                (chatClicked)="selectChat(chat.id)"
                (menuOpened)="menuOpened.emit()"
                (menuClosed)="menuClosed.emit()" />
            }
          </div>
        </div>
      }
    }
  `,
})
export class FlowpilotChatsListComponent {
  /** INJECTIONS **/
  /****/
  private readonly chatService = inject(FlowpilotChatService);

  /** OUTPUTS **/
  /****/
  readonly menuOpened = output<void>();

  /****/
  readonly menuClosed = output<void>();

  /** PROPERTIES **/
  /****/
  protected readonly selectedChat = this.chatService.selectedChatSignal;

  /****/
  private readonly chats = this.chatService.chatsSignal;

  /****/
  protected readonly pinnedChats = computed(() =>
    this.chats().filter(c => !!c.pinned && false)
  );

  /****/
  protected readonly recentChats = computed(() =>
    this.chats().filter(c => !c.pinned)
  );

  /****/
  protected readonly chatTypes = [
    { name: 'Pinned', data: this.pinnedChats },
    { name: 'Recents', data: this.recentChats },
  ];

  protected selectChat(id: number) {
    this.chatService.selectChat(id);
  }
}
